import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { useMyContext } from '../../../context/MyContext';
import '../../css/custom-scrollbar.css';
import { FaUser, FaUniversity } from "react-icons/fa";
import { Base_Url, Url_For_View_Document, accountUpdaterequest, resetuserpasswordapi } from '../../../config/config';
import { FaEye } from 'react-icons/fa'
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import {
  FaIdCard,
  FaAddressCard,
  FaTimes,
  FaEdit,
  FaSave,
} from 'react-icons/fa';



const ViewAllCustomer = ({ isopen, onClose, customer }) => {
  const { isDarkMode } = useMyContext();
  const [isEditMode, setIsEditMode] = useState(false);
  const [cancelledChequeFile, setCancelledChequeFile] = useState(null);
  const [mailScreenshotFile, setMailScreenshotFile] = useState(null);
  const [isResetMode, setIsResetMode] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onErrors = (errors) => {
    toast.error("Please fix the errors in the form.");
  };



  const handleResetPassword = async () => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+=\[\]{};':"\\|,.<>/?]).{8,}$/;

    if (!passwordRegex.test(password)) {
      toast.error("Password must be at least 8 characters long and include 1 uppercase letter and 1 special character.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(
        Base_Url + resetuserpasswordapi,
        {
          email: customer.email,
          password: password,
          c_password: confirmPassword,
        },
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        setIsResetMode(false);
        setPassword("");
        setConfirmPassword("");
        onClose();

      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("Failed to reset password.");
    }
  };

  useEffect(() => {
    if (customer) {
      reset({
        Id: customer.id || '',
        Name: customer.name || '',
        email: customer.email || '',
        phone: customer.phone || '',
        company_name: customer.company_name || '',
        company_type: customer.company_type || '',
        status: customer.status || '0',
        profile_flag: customer.profile_flag || '0',
        user_address_image: customer.user_address_image || '',
        user_pancard_image: customer.user_pancard_image || '',
        user_gst_image: customer.user_gst_image || '',
        aadhar_status: customer.aadhar_status || '0',
        pan_card_status: customer.pan_card_status || '0',
        gst_status: customer.gst_status || '0',
        aadhar_number: customer.aadhar_number || '',
        pancard_number: customer.pancard_number || '',
        gst_number: customer.gst_number || '',
        role: customer.role || '',
        txn_amount: customer.txn_amount || '',
        wallet_status: customer.wallet_status || '0',
        create_date: customer.create_date || '',
        timestamp: customer.timestamp || '',
        account_holder_name: customer.account_holder_name || '',
        account_no: customer.account_no || '',
        bank_name: customer.bank_name || '',
        ifsc_code: customer.ifsc_code || '',
      });
      setCancelledChequeFile(null);
      setMailScreenshotFile(null);
    }
  }, [customer, reset]);

  const handleFileChange = (event, setFileFunction) => {
    const file = event.target.files[0];
    if (file) {
      setFileFunction(file);
    }
  };

  const ViewDocument = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const handleClose = () => {
    setIsEditMode(false);
    setCancelledChequeFile(null);
    setMailScreenshotFile(null);
    onClose();
  };

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append('user_id', customer.id || '');
    formData.append('bank_name', data.bank_name || '');
    formData.append('ifsc_code', data.ifsc_code || '');
    formData.append('account_holder', data.account_holder_name || '');
    formData.append('account_no', data.account_no || '');

    if (cancelledChequeFile) {
      formData.append('cancel_check', cancelledChequeFile);
    }
    if (mailScreenshotFile) {
      formData.append('mail_screenshort', mailScreenshotFile);
    }
    try {
      const response = await axios.post(Base_Url + accountUpdaterequest, formData, {
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'multipart/form-data',

        },
      });

      if (response.data.status === "success") {
        toast.success(response.data.message);
        handleClose();
      } else {
        toast.error(response.data.message.cancel_check);
        toast.error(response.data.message.mail_screenshort);
        toast.error(response.data.message.bank_name);
        toast.error(response.data.message.account_holder);
      }
    } catch (error) {
      console.error('API Error:', error);
      toast.error('Failed to update account details');
    }
  };

  const inputClass = `p-1 text-sm border border-gray-300 dark:border-gray-700 w-full rounded focus:outline-none focus:ring-1 focus:ring-black dark:focus:ring-white focus:border-black dark:focus:border-white bg-white dark:bg-black dark:text-white disabled:bg-gray-50 dark:disabled:bg-gray-900 disabled:text-gray-500`;
  const labelClass = "block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1";
  const sectionClass = "p-1 rounded border border-gray-200 dark:border-gray-800";
  const sectionTitleClass = "text-xs font-semibold mb-3 text-black dark:text-white flex items-center uppercase tracking-wide";

  return (
    <Dialog
      open={isopen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: "rounded-md overflow-hidden"
      }}
    >
      <DialogTitle className="bg-black text-white relative py-2.5 px-4">
        <h2 className="text-xs font-semibold text-white flex items-center">
          <FaUser className="mr-2" size={14} />
          Customer Details
        </h2>
        <IoIosCloseCircle
          className="absolute top-2 right-3 cursor-pointer hover:opacity-70 transition-opacity"
          size={16}
          onClick={handleClose}
        />
      </DialogTitle>

      <DialogContent className="bg-white dark:bg-black custom-scrollbar p-0" style={{ maxHeight: '75vh' }}>
        <div className="py-4">
          <form className="space-y-3 font-sans" onSubmit={handleSubmit(onSubmit, onErrors)}>

            {/* Primary Information Section */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard className="mr-1.5" size={11} />
                Primary Information
              </h3>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>ID</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('Id')}
                    disabled={!isEditMode}
                  />
                </div>

                <div>
                  <label className={labelClass}>Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('Name')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>
            </div>

            {/* Contact Information Section */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaAddressCard className="mr-1.5" size={11} />
                Contact Information
              </h3>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>Email</label>
                  <input
                    type="email"
                    className={inputClass}
                    {...register('email')}
                    disabled={!isEditMode}
                  />
                </div>

                <div>
                  <label className={labelClass}>Phone</label>
                  <input
                    type="tel"
                    className={inputClass}
                    {...register('phone')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>
            </div>

            {/* Company Information Section */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard className="mr-1.5" size={11} />
                Company Information
              </h3>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>Company Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('company_name')}
                    disabled={!isEditMode}
                  />
                </div>

                <div>
                  <label className={labelClass}>Company Type</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('company_type')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 mt-3">
                <div>
                  <label className={labelClass}>GST Number</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('gst_number')}
                    disabled={!isEditMode}
                  />
                </div>

                <div>
                  <label className={labelClass}>Profile Status</label>
                  <select
                    {...register('profile_flag')}
                    className={inputClass}
                    disabled={!isEditMode}
                  >
                    <option value="0">User Unverified</option>
                    <option value="1">User Verified</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Password Reset Section */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard className="mr-1.5" size={11} />
                Password Management
              </h3>

              <div className="grid grid-cols-2 gap-3">
                <div className="relative">
                  <label className={labelClass}>New Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className={`${inputClass} pr-8`}
                      disabled={!isResetMode}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer text-gray-400"
                    >
                      {showPassword ? <FiEyeOff size={14} /> : <FiEye size={14} />}
                    </span>
                  </div>
                </div>

                <div className="relative">
                  <label className={labelClass}>Confirm Password</label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className={`${inputClass} pr-8`}
                      disabled={!isResetMode}
                    />
                    <span
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer text-gray-400"
                    >
                      {showConfirmPassword ? <FiEyeOff size={14} /> : <FiEye size={14} />}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Document Information */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaIdCard className="mr-1.5" size={11} />
                Document Information
              </h3>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>Aadhar Number</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('aadhar_number')}
                    disabled={!isEditMode}
                  />
                </div>

                <div>
                  <label className={labelClass}>PAN Card Number</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('pancard_number')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="space-y-3 mt-3">
                <div>
                  <div className="flex items-center justify-between mb-1">
                    <label className={labelClass + " mb-0"}>Aadhar Card Image</label>
                    {customer?.user_address_image && (
                      <button
                        type="button"
                        className="flex items-center text-[11px] text-black dark:text-white hover:opacity-70"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_address_image)}
                      >
                        <FaEye size={12} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      className="text-xs w-full"
                    />
                  ) : (
                    <input
                      type="text"
                      {...register('user_address_image')}
                      className={inputClass}
                      disabled
                    />
                  )}
                </div>

                <div>
                  <div className="flex items-center justify-between mb-1">
                    <label className={labelClass + " mb-0"}>PAN Card Image</label>
                    {customer?.user_pancard_image && (
                      <button
                        type="button"
                        className="flex items-center text-[11px] text-black dark:text-white hover:opacity-70"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_pancard_image)}
                      >
                        <FaEye size={12} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      className="text-xs w-full"
                    />
                  ) : (
                    <input
                      type="text"
                      {...register('user_pancard_image')}
                      className={inputClass}
                      disabled
                    />
                  )}
                </div>

                <div>
                  <div className="flex items-center justify-between mb-1">
                    <label className={labelClass + " mb-0"}>GST Certificate</label>
                    {customer?.user_gst_image && (
                      <button
                        type="button"
                        className="flex items-center text-[11px] text-black dark:text-white hover:opacity-70"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.user_gst_image)}
                      >
                        <FaEye size={12} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      className="text-xs w-full"
                    />
                  ) : (
                    <input
                      type="text"
                      {...register('user_gst_image')}
                      className={inputClass}
                      disabled
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Bank Account Details */}
            <div className={sectionClass}>
              <h3 className={sectionTitleClass}>
                <FaUniversity className="mr-1.5" size={11} />
                Bank Account Details
              </h3>

              <p className="text-[11px] text-gray-500 dark:text-gray-400 mb-3 border border-gray-200 dark:border-gray-800 p-2 rounded">
                Please ensure all bank details are accurate. These details will be used for processing payments and transactions.
              </p>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>Account Holder Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('account_holder_name')}
                    disabled={!isEditMode}
                  />
                </div>

                <div>
                  <label className={labelClass}>Bank Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('bank_name')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 mt-3">
                <div>
                  <label className={labelClass}>Account Number</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('account_no')}
                    disabled={!isEditMode}
                  />
                </div>

                <div>
                  <label className={labelClass}>IFSC Code</label>
                  <input
                    type="text"
                    className={inputClass}
                    {...register('ifsc_code')}
                    disabled={!isEditMode}
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 mt-3">
                <div>
                  <div className="flex items-center justify-between mb-1">
                    <label className={labelClass + " mb-0"}>Cancelled Cheque</label>
                    {customer?.cancel_check_image && (
                      <button
                        type="button"
                        className="flex items-center text-[11px] text-black dark:text-white hover:opacity-70"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.cancel_check_image)}
                      >
                        <FaEye size={12} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      onChange={(e) => handleFileChange(e, setCancelledChequeFile)}
                      className="text-xs w-full"
                    />
                  ) : (
                    <div className={inputClass + " bg-gray-50 dark:bg-gray-900"}>
                      {customer?.cancel_check_image || 'No file uploaded'}
                    </div>
                  )}
                </div>

                <div>
                  <div className="flex items-center justify-between mb-1">
                    <label className={labelClass + " mb-0"}>Account Approval Mail</label>
                    {customer?.account_appruve_mail && (
                      <button
                        type="button"
                        className="flex items-center text-[11px] text-black dark:text-white hover:opacity-70"
                        onClick={() => ViewDocument(Url_For_View_Document + customer.account_appruve_mail)}
                      >
                        <FaEye size={12} className="mr-1" /> View
                      </button>
                    )}
                  </div>
                  {isEditMode ? (
                    <input
                      type="file"
                      onChange={(e) => handleFileChange(e, setMailScreenshotFile)}
                      className="text-xs w-full"
                    />
                  ) : (
                    <div className={inputClass + " bg-gray-50 dark:bg-gray-900"}>
                      {customer?.account_appruve_mail || 'No file uploaded'}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap gap-2 pt-1">
              <button
                type="button"
                onClick={() => setIsEditMode(!isEditMode)}
                className="text-xs font-medium py-2 px-4 rounded border border-black dark:border-white text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors flex items-center"
              >
                {isEditMode ? (
                  <>
                    <FaTimes className="mr-1.5" size={11} /> Cancel Editing
                  </>
                ) : (
                  <>
                    <FaEdit className="mr-1.5" size={11} /> Edit Details
                  </>
                )}
              </button>

              {isEditMode && (
                <button
                  type="submit"
                  className="text-xs font-medium py-2 px-4 rounded bg-black text-white dark:bg-white dark:text-black hover:opacity-80 transition-all flex items-center"
                >
                  <FaSave className="mr-1.5" size={11} /> Save Changes
                </button>
              )}

              <button
                type="button"
                onClick={() => setIsResetMode(!isResetMode)}
                className="text-xs font-medium py-2 px-4 rounded border border-black dark:border-white text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors flex items-center"
              >
                {isResetMode ? 'Cancel Reset' : 'Reset Password'}
              </button>

              {isResetMode && (
                <button
                  onClick={handleResetPassword}
                  className="text-xs font-medium py-2 px-4 rounded bg-black text-white dark:bg-white dark:text-black hover:opacity-80 transition-all"
                  type="button"
                >
                  Confirm Reset
                </button>
              )}
            </div>

          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewAllCustomer;